import React, { useEffect, useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { Button, DropDownButton, DropDownButtonItemClickEvent, SplitButton } from '@progress/kendo-react-buttons';
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as svg from '@progress/kendo-svg-icons';
import { CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import { SvgIcon } from '@progress/kendo-react-common';
import { Card, CardBody, PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { useReduxDispatch } from '../../../../../../redux/hooks';
import { AssetGrid } from '../../../../../Asset/AssetGrid';
import { ITicketAsset } from '../../../../../../types/Ticket/ITicketAsset';
import { IAsset } from '../../../../../../types/Asset/IAsset';
import { AssetApi } from '../../../../../../redux/api/AssetApi';
import { ITicketContact } from '../../../../../../types/Ticket/ITicketContact';

const AssetModal: React.FC = () => {
    const dispatch = useReduxDispatch();
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const { data: ticket, isLoading } = TicketApi.useGetTicketDetailsQuery({ ticketId: parseInt(ticketId) });
    const [useDesc, setUseDesc] = React.useState<boolean>(true);
    const [description, setDescription] = React.useState<string>();
    const [freeText, setFreeText] = React.useState<string>();
    const [filter, setFilter] = useState<CompositeFilterDescriptor>(null)
    const [linkedAssets, setLinkedAssets] = useState<ITicketAsset[]>([]);
    type assContacts = { contacts: ITicketContact[], hasChanged: boolean };
    const [associatedContacts, setAssociatedContacts] = useState<assContacts>({} as assContacts);
    const [saveAssociatedContacts, { isLoading: savingContacts }] = TicketApi.useSaveAssociatedContactsMutation();
    const [error, setError] = useState<string>();
    const [saveTicketAssets, { isLoading: saving }] = TicketApi.useSaveLinkedAssetsMutation();
    const from = new URLSearchParams(window.location.search).get('from');
    const { data: tenant } = UserApi.useGetTenantQuery()
    const { data: ticketAssets, isLoading: loadingAssets } = TicketApi.useGetLinkedAssetsQuery(ticket?.ID, { skip: !ticket?.ID });

    //Load the existing linked Kbs into state
    useEffect(() => {
        if (ticketAssets) {
            setLinkedAssets(ticketAssets);
        }
    }, [ticketAssets]);

    //Load associated COntacts for the ticket
    useEffect(() => {
        if (ticket) {
            setAssociatedContacts({ contacts: ticket.AssociatedContacts, hasChanged: false });
        }
    }, [ticket]);

    const contactSelected = (e: { value: ITicketContact[] }) => {
        setAssociatedContacts({ contacts: e.value, hasChanged: true });
    }

    const onFilter = (event: InputChangeEvent) => {
        console.log('Filter', event);
        //setStaff(filterBy(staffList?.slice(), event.filter));
        setFilter({ filters: [{ value: event.value, field: 'Title', operator: 'contains' }] } as CompositeFilterDescriptor);
    }
    const filteredResults = ticketAssets ? filterBy(ticketAssets, filter) : [];

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        navigate('/ticket/' + ticketId);
    }

    const onSearchClicked = () => {
        //doSearch();
    }

    const onItemClick = (event: DropDownButtonItemClickEvent) => {
        setError('')

        //go back
        //navigate(-1);
    }

    const saveLinkedAsset = () => {
        Promise.all([
            associatedContacts?.hasChanged && saveAssociatedContacts({ ticketId: ticket.ID, contactIds: associatedContacts.contacts?.map(c => c.Contact_Id) }).unwrap(),
            saveTicketAssets({ ticketId: ticket.ID, assets: linkedAssets, append: false }).unwrap()
        ])
            .then(() => {
                navigate('/ticket/' + ticketId);
            })
            .catch((err) => {
                setError(err.message || 'An error occurred while saving.');
            });

    }

    const assetSelected = (e: { value: IAsset[] }) => {
        setLinkedAssets(e.value.map(a => { return { Asset_Id: a.ID, Call_Id: ticket?.ID, Contact_Id: a.Contact_Id > 0 ? a.Contact_Id : 0 } as ITicketAsset }));
    }


    const { data: assets } = AssetApi.useGetAssetsQuery({ contactId: 0, locationId: ticket.Company_Address_Id }, { skip: !ticket.Company_Address_Id })

    const contactAssets = assets?.filter((a) => a.Contact_Id === ticket.Company_Contact)
    const locationAssets = assets?.filter((a) => a.Contact_Id !== ticket.Company_Contact)
    const selectedLocationAssetCount = linkedAssets?.filter(a => a.Contact_Id !== ticket.Company_Contact).length;
    const selectedContactAssetCount = linkedAssets?.filter(a => a.Contact_Id === ticket.Company_Contact).length;

    if (!userProfile?.Features.Call_Hierarchy) return <></>;
    const canAdd = userProfile?.Features.Add_Asset;
    return (
        <div>
            <Window modal={true} className='cool-window' minimizeButton={() => null} title={<div className='flex align-items-center'><SvgIcon icon={svg.toggleFullScreenModeIcon} />&nbsp;Asset Results</div>} onClose={onWindowClose} initialHeight={Math.min(850, window.innerHeight)} initialWidth={Math.min(1200, window.innerWidth)} stage={stage} onStageChange={onStageChange} >
                <div className='position-relative'>
                    <Outlet></Outlet>
                    {(isLoading || saving || loadingAssets || savingContacts) && <PartialSpinny />}
                    <Card>
                        <CardBody>
                            {/* <AssetGrid selectedAssets={linkedAssets.map(l => l.Asset_Id)} companyId={ticket?.Company_Id} locationId={ticket.Company_Address_Id} contactId={ticket.Company_Contact} onChange={assetSelected} /> */}
                            <PanelBar expandMode='single'>
                                <PanelBarItem selected={true} expanded={true} title={`${ticket.Contact_Name} ${userProfile.Phrases.Asset}s (${selectedContactAssetCount} of ${contactAssets?.length || 0} selected)`} >
                                    <AssetGrid contactId={ticket.Company_Contact} companyId={ticket.Company_Id} onChange={assetSelected} selectedAssets={linkedAssets.map(l => l.Asset_Id)} />
                                </PanelBarItem>
                                <PanelBarItem selected={true} expanded={false} title={`${ticket.Address_Name || ''} ${userProfile.Phrases.Asset}s (${selectedLocationAssetCount} of ${locationAssets?.length || 0} selected)`}  >
                                    <AssetGrid showContactLinkColumn={true} associatedContacts={associatedContacts?.contacts} contactId={ticket.Company_Contact} locationId={ticket.Company_Address_Id} companyId={ticket.Company_Id} onContactChange={contactSelected} onChange={assetSelected} selectedAssets={linkedAssets.map(l => l.Asset_Id)} />
                                </PanelBarItem>
                            </PanelBar>
                        </CardBody>
                    </Card>
                </div>
                <WindowActionsBar>
                    <h6>{linkedAssets?.length} selected</h6>
                    <Button className='rev-primary-button' size='large' onClick={saveLinkedAsset} svgIcon={svg.linkIcon} >{`Link ${userProfile?.Phrases.Asset}s to ${userProfile?.Phrases.CallPhrase}`}</Button>
                    {canAdd && <Button title={`Add ${userProfile?.Phrases.Asset}`} size='large' style={{ backgroundColor: '#bfbfbf' }} onClick={() => navigate('add')} svgIcon={svg.plusOutlineIcon} >{`${userProfile?.Phrases.Asset}`}</Button>}
                    <Button fillMode='outline' onClick={() => onWindowClose()} svgIcon={svg.cancelIcon} className='justify-content-end' size='large'>
                        Cancel
                    </Button>
                </WindowActionsBar>
            </Window>
        </div >
    );
};

export default AssetModal;